module.exports = __webpack_public_path__ + "static/img/gouwuc.2bfeb4c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/gouwuc.png
// module id = cR/Z
// module chunks = 1